/**
 * @description 입력받은 element에서 filter에 부합하는 가장 가까운 element를 반환.
 * @function closest
 * @param {HTMLElement} element
 * @param {String} filter
 * @returns {Array} filter 조건에 부합하는 element 하나를 Array 넣어 반환. 없다면, 빈 배열 반환
 */
function closest(element: HTMLElement, filter: String) {
  let matchesFn: any;

  ///
  /// 1. 벤더 리스트
  ///
  [
    "matches",
    "webkitMatchesSelector",
    "mozMatchesSelector",
    "msMatchesSelector",
    "oMatchesSelector"
  ].some(function(fn) {
    if (typeof (document.body as any)[fn] === "function") {
      matchesFn = fn;
      return true;
    }
    return false;
  });

  let parent: any;
  let result: any = [];

  ///
  /// 2. 조상 element를 순회하며, filter 조건에 부합하는 element 검색
  ///
  while (element) {
    parent = element.parentElement;
    if (parent && parent[matchesFn](filter)) {
      result.push(parent);
      return result;
    }
    element = parent;
  }

  return result;
}

export { closest };
